// extracted by mini-css-extract-plugin
export var container = "_d2-0";